import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const SystemOutlineIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="SystemOutlineIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/system/outline">
            <path
                fill="none"
                d="M3.91406 13.5H19.9141C20.7425 13.5 21.4141 14.1716 21.4141 15V19C21.4141 19.8284 20.7425 20.5 19.9141 20.5H3.91406C3.08564 20.5 2.41406 19.8284 2.41406 19V15C2.41406 14.1716 3.08564 13.5 3.91406 13.5ZM6.54883 15.5254C5.7204 15.5254 5.04883 16.197 5.04883 17.0254C5.04909 17.8536 5.72056 18.5254 6.54883 18.5254C7.37709 18.5254 8.04856 17.8536 8.04883 17.0254C8.04883 16.197 7.37726 15.5254 6.54883 15.5254ZM4.08594 3.5H20.0859C20.9144 3.5 21.5859 4.17157 21.5859 5V9C21.5859 9.82843 20.9144 10.5 20.0859 10.5H4.08594C3.25751 10.5 2.58594 9.82843 2.58594 9V5C2.58594 4.17157 3.25751 3.5 4.08594 3.5ZM6.7207 5.52539C5.89228 5.52539 5.2207 6.19696 5.2207 7.02539C5.22097 7.85359 5.89244 8.52539 6.7207 8.52539C7.54897 8.52539 8.22044 7.85359 8.2207 7.02539C8.2207 6.19696 7.54913 5.52539 6.7207 5.52539Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
            </path>
        </g>
    </SvgIcon>
)
